import React, { useEffect } from "react";
import "./Hero.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Hero = () => {
  // Ganti nomor telepon berikut dengan nomor yang ingin Anda tuju
  const phoneNumber = "+6289502606853";

  const openWhatsApp = () => {
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, "_blank");
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
    });
  }, []);

  return (
    <div className='container-light'>
      <div className='content-hero'>
        <p className='' data-aos='fade-up '>
          Good City
        </p>
        <p className='title-border ' data-aos='fade-up'>
          GREAt PEOPLE
        </p>
        <p className='title-hero'>
          Selamat Datang DI Website Kampung Mundu RT05/04 Lubang Buaya Jakarta
          Timur
        </p>
        <button className='btn-wa' onClick={openWhatsApp}>
          whatsapp
        </button>
      </div>
    </div>
  );
};

export default Hero;
